import Moment from "moment"

Moment.locale('zh-cn');

export default {

    /**
     * 得到当前Unix时间戳
     */
    now() {
        return Moment().unix();
    },

    /**
     * 将时间戳转换成 date 日期格式 (2018-01-01)
     * @param time
     * @returns {string}
     */
    asDate(time) {
        return Moment(parseInt(time)).format("L");
    },

    /**
     * 将时间戳转换成 date 日期格式包含时分秒 (2018-01-01 01:01:00)
     * @param time
     * @returns {string}
     */
    asDatetime(time) {
        return Moment(parseInt(time)).format("lll");
    },

    /**
     * 将时间戳转换成 date 日期格式包含时分秒 (2018-01-01 01:01:00)
     * @param time
     * @returns {string}
     */
    asDateDay(time) {
        return Moment(parseInt(time)).format("l");
    }

    

}


// WEBPACK FOOTER //
// ./src/common/time.js